function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.math.trunc.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.from.js";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import _ from 'lodash';
import _onActionClick from "./onActionClick";
import getResourceID from "../../../util/getResourceId";
import { showErrors } from "../../../util/errors";
import { getObject, storeObject } from "../../../util/common";
import generalRequest from "../../../api/generalRequest";
import { applicationCurrentApplicationSelector, applicationIdSelector, applicationLoadingSelector, multipleNotesShow, multipleNotesSetNote, notesSetAddingPrivateAction, notesSetAddingAction, notesUpdateNewPrivateNoteAction, notesUpdateNewNoteAction, addingPrivateNotes, addingNotes, permissionsSelector, notesDeleteAction, notesInsertAction, notesAddFileNewPrivateNoteAction, notesAddFileNewNoteAction, notesRemoveFileNewPrivateNoteAction, notesRemoveFileNewNoteAction, notesClearFilesNewPrivateNoteAction, notesClearFilesNewNoteAction, newNoteLoadingSelector, newPrivateNoteLoadingSelector, newNoteSelector, applicationAgentId, newPrivateNoteSelector, notesSetNewPrivateNoteLoadingAction, notesSetNewNoteLoadingAction } from '@applyboard/ab-common';
import { raiseErrorMessage, raiseSuccessMessage } from '@applyboard/ui-utils';
import { applicationSetStudentProfileAction, applicationSetRequirementsLoadingAction, applicationSetApplicationAction, applicationSetDatesAction, applicationSetIdAction, applicationSetOtherApplicationsAction, applicationSetOtherApplicationsLoadingAction, applicationSetPermissionsAction, applicationSetRequirementsLoadedAction, applicationSetTabAction, notesSetLoadingAction } from "../../../store/actions/application";
import { getAdditionalApplicationsRequest, getInitialApplicationRequest, createApplicationNoteRequest, deleteApplicationNoteRequest, patchApplicationDateRequest } from "../../../api/application";
import { applicationStudentIdSelector, applicationOldStudentIdSelector, applicationOtherApplicationsLoadingSelector, applicationOtherApplicationsSelector, rowloadingSelector } from "../../../store/selectors/application";
import createNoteFromTemplate from "../../../enhancers/createNoteFromTemplate";
var loadStudentProfile = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(studentHref, dispatch) {
    var response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          response = null;
          _context.prev = 1;
          _context.next = 4;
          return generalRequest(studentHref);
        case 4:
          response = _context.sent;
          dispatch(applicationSetStudentProfileAction(response));
          _context.next = 13;
          break;
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](1);
          console.error(_context.t0);
          raiseErrorMessage('There was an error trying to receive the profile associated with this application');
          return _context.abrupt("return", null);
        case 13:
          return _context.abrupt("return", response);
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 8]]);
  }));
  return function loadStudentProfile(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

// -------------------------------------------------------------
// Requirement List Actions
// -------------------------------------------------------------
var loadApplicationRequirements = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(applicationId, dispatch) {
    var response;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          dispatch(applicationSetRequirementsLoadingAction(true));
          response = null;
          _context2.prev = 2;
          response = {
            data: {
              data: []
            }
          };
          _context2.next = 11;
          break;
        case 6:
          _context2.prev = 6;
          _context2.t0 = _context2["catch"](2);
          console.error(_context2.t0);
          raiseErrorMessage('There was an error retrieving the requirements associated with this application');
          return _context2.abrupt("return", null);
        case 11:
          dispatch(applicationSetRequirementsLoadingAction(false));
          return _context2.abrupt("return", response);
        case 13:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 6]]);
  }));
  return function loadApplicationRequirements(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

// -------------------------------------------------------------
// Initialize Application Actions
// -------------------------------------------------------------

export var loadBaseApplication = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(applicationId, dispatch) {
    var app;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return getInitialApplicationRequest(applicationId);
        case 2:
          app = _context3.sent;
          delete app.student; // do not update the student.
          return _context3.abrupt("return", dispatch(applicationSetApplicationAction(app)));
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function loadBaseApplication(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();
var loadFullApplication = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(applicationId, dispatch, getState) {
    var requests, app, needExtraInfoFor, state, application;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          requests = [];
          _context4.prev = 1;
          _context4.next = 4;
          return getInitialApplicationRequest(applicationId);
        case 4:
          app = _context4.sent;
          needExtraInfoFor = _.filter(Object.keys(app), function (x) {
            return app[x] && app[x].href != null;
          });
          _.each(needExtraInfoFor, function (idx) {
            var currentApp = app[idx];
            if (!currentApp) {
              console.warn("cannot find information on ".concat(idx));
              return;
            }
            if (currentApp.id) {
              return;
            }
            if (!currentApp.href) {
              console.warn('Not enough info to retrieve object', currentApp);
              return;
            }
            // TODO: replace this with useStudentProfile hook
            requests.push(loadStudentProfile(currentApp.href, dispatch));
          });
          dispatch(applicationSetApplicationAction(app));
          _context4.next = 14;
          break;
        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4["catch"](1);
          console.error("error retrieving data for application ".concat(applicationId));
          return _context4.abrupt("return", null);
        case 14:
          state = getState();
          application = applicationCurrentApplicationSelector(state);
          return _context4.abrupt("return", Promise.all(requests).then(function () {
            return application;
          }));
        case 17:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[1, 10]]);
  }));
  return function loadFullApplication(_x7, _x8, _x9) {
    return _ref4.apply(this, arguments);
  };
}();
export var loadOtherApplications = function loadOtherApplications() {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dispatch, getState) {
      var _application$student;
      var state, application, applicationId, studentId, otherApps;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            state = getState();
            application = applicationCurrentApplicationSelector(state);
            applicationId = application === null || application === void 0 ? void 0 : application.id;
            studentId = application === null || application === void 0 ? void 0 : (_application$student = application.student) === null || _application$student === void 0 ? void 0 : _application$student.id;
            if (studentId) {
              _context5.next = 6;
              break;
            }
            return _context5.abrupt("return");
          case 6:
            dispatch(applicationSetOtherApplicationsLoadingAction(true));
            _context5.next = 9;
            return getAdditionalApplicationsRequest(studentId);
          case 9:
            otherApps = _context5.sent;
            dispatch(applicationSetOtherApplicationsAction(_.filter(otherApps, function (x) {
              return getResourceID(x.href) !== applicationId;
            })));
            dispatch(applicationSetOtherApplicationsLoadingAction(false));
            dispatch(applicationSetRequirementsLoadedAction(true));
          case 13:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x10, _x11) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var initApplication = function initApplication(applicationId, permissions, initialTab) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(dispatch, getState) {
      var response;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            dispatch(applicationSetIdAction(applicationId));
            dispatch(applicationSetPermissionsAction(permissions));
            dispatch(notesSetLoadingAction(true));
            if (initialTab) {
              dispatch(applicationSetTabAction(initialTab.replace(/-/, ' ')));
            }
            response = [];
            _context6.prev = 5;
            _context6.next = 8;
            return Promise.all([loadFullApplication(applicationId, dispatch, getState), permissions && permissions.index_requirement && loadApplicationRequirements(applicationId, dispatch)]);
          case 8:
            response = _context6.sent;
            _context6.next = 15;
            break;
          case 11:
            _context6.prev = 11;
            _context6.t0 = _context6["catch"](5);
            console.error(_context6.t0);
            raiseErrorMessage('There was an error loading this page.');
          case 15:
            dispatch(notesSetLoadingAction(false));
            return _context6.abrupt("return", response);
          case 17:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[5, 11]]);
    }));
    return function (_x12, _x13) {
      return _ref6.apply(this, arguments);
    };
  }();
};

// used by the Application Page to init the page
var applicationState = createStructuredSelector({
  id: applicationIdSelector,
  application: applicationCurrentApplicationSelector,
  loading: applicationLoadingSelector
});
var applicationDispatch = {
  init: initApplication,
  set_tab: applicationSetTabAction
};
export var applicationEnhancer = connect(applicationState, applicationDispatch);

// -------------------------------------------------------------
// Application Start Dates Actions
// -------------------------------------------------------------
var applicationDatesSave = function applicationDatesSave() {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(dispatch, getState) {
      var state, applicationId, application, mainIntakeId, intake, eslIntakeId, intake_esl, esl_actual_start_date, program_actual_start_date, esl_alternate_actual_start_date, program_alternate_actual_start_date, response;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            state = getState();
            applicationId = applicationIdSelector(state);
            application = applicationCurrentApplicationSelector(state);
            mainIntakeId = application.mainIntakeId, intake = application.intake, eslIntakeId = application.eslIntakeId, intake_esl = application.intake_esl, esl_actual_start_date = application.esl_actual_start_date, program_actual_start_date = application.program_actual_start_date, esl_alternate_actual_start_date = application.esl_alternate_actual_start_date, program_alternate_actual_start_date = application.program_alternate_actual_start_date;
            response = null;
            _context7.prev = 5;
            _context7.next = 8;
            return patchApplicationDateRequest(applicationId, mainIntakeId, intake, eslIntakeId, intake_esl, esl_actual_start_date, program_actual_start_date, esl_alternate_actual_start_date, program_alternate_actual_start_date);
          case 8:
            response = _context7.sent;
            dispatch(applicationSetDatesAction(mainIntakeId, intake, eslIntakeId, intake_esl, esl_actual_start_date, program_actual_start_date, esl_alternate_actual_start_date, program_alternate_actual_start_date));

            // reloading the application here because ApplicationDeadlines and ApplicationIntake
            // both rely on application API endpoint for deadline data and will not be reading those
            // values from state
            // TODO: clean this up when we have better way to manage the application object with hooks
            _context7.next = 12;
            return loadBaseApplication(applicationId, dispatch);
          case 12:
            raiseSuccessMessage('Start date(s) updated');
            _context7.next = 19;
            break;
          case 15:
            _context7.prev = 15;
            _context7.t0 = _context7["catch"](5);
            if (_context7.t0.errors && _context7.t0.errors.intake != null && _context7.t0.errors.intake !== '') {
              raiseErrorMessage("Error with Academic Start Date: ".concat(_context7.t0.errors.intake));
            } else if (_context7.t0.errors && _context7.t0.errors.intake_esl != null && _context7.t0.errors.intake_esl !== '') {
              raiseErrorMessage("Error with ESL Start Date: ".concat(_context7.t0.errors.intake_esl));
            } else if (_context7.t0.response && _context7.t0.response.data && _context7.t0.response.data.error && typeof _context7.t0.response.data.error === 'string') {
              raiseErrorMessage(_context7.t0.response.data.error);
            } else {
              showErrors(_context7.t0);
            }

            // Rethrow the error to be caught by the enhancer
            throw _context7.t0;
          case 19:
            return _context7.abrupt("return", response);
          case 20:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[5, 15]]);
    }));
    return function (_x14, _x15) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var applicationSidebarProps = createStructuredSelector({
  applicationId: applicationIdSelector,
  application: applicationCurrentApplicationSelector,
  rowloading: rowloadingSelector,
  otherApplications: applicationOtherApplicationsSelector,
  otherApplicationsLoading: applicationOtherApplicationsLoadingSelector,
  loading: applicationLoadingSelector
});
export var applicationSidebarDispatch = function applicationSidebarDispatch(dispatch, ownProps) {
  return {
    setApplicationDates: function setApplicationDates(dateId, date, eslDateId, eslDate, eslActualStartDate, programActualStartDate, eslAlternateActualStartDate, programAlternateActualStartDate) {
      return dispatch(applicationSetDatesAction(dateId, date, eslDateId, eslDate, eslActualStartDate, programActualStartDate, eslAlternateActualStartDate, programAlternateActualStartDate));
    },
    onDateSave: function onDateSave() {
      return dispatch(applicationDatesSave());
    },
    onActionClick: function () {
      var _onActionClick2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(params) {
        var _ref8, flagName, flagValue, eventData, payload, queryString;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _ref8 = params || {}, flagName = _ref8.flagName, flagValue = _ref8.flagValue, eventData = _ref8.eventData, payload = _ref8.payload, queryString = _ref8.queryString;
              _context8.next = 3;
              return dispatch(_onActionClick({
                flagName: flagName,
                flagValue: flagValue,
                payload: payload,
                queryString: queryString,
                history: ownProps.history,
                isMarkdownRendererEnabled: ownProps.isMarkdownRendererEnabled
              }));
            case 3:
              return _context8.abrupt("return", eventData);
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function onActionClick(_x16) {
        return _onActionClick2.apply(this, arguments);
      }
      return onActionClick;
    }(),
    onSubmittedToSchoolClick: function onSubmittedToSchoolClick(schoolSubmitted) {
      return dispatch(_onActionClick({
        flagName: 'submitted',
        flagValue: schoolSubmitted,
        history: ownProps.history,
        isMarkdownRendererEnabled: ownProps.isMarkdownRendererEnabled
      }));
    },
    onReadyToSubmitClick: function onReadyToSubmitClick(readyToSubmit) {
      return dispatch(_onActionClick({
        flagName: 'ready_to_submit',
        flagValue: readyToSubmit,
        history: ownProps.history,
        isMarkdownRendererEnabled: ownProps.isMarkdownRendererEnabled
      }));
    },
    onReadyForVisaClick: function onReadyForVisaClick(readyForVisa, payload) {
      return dispatch(_onActionClick({
        flagName: 'ready_for_visa',
        flagValue: readyForVisa,
        payload: payload,
        history: ownProps.history,
        isMarkdownRendererEnabled: ownProps.isMarkdownRendererEnabled
      }));
    },
    onFileDrop: function onFileDrop(files) {
      return dispatch(onStatusFileDrop(files));
    },
    onFileDelete: function onFileDelete() {
      return dispatch(onStatusFileDelete());
    }
  };
};
export var applicationSidebarEnhancer = connect(applicationSidebarProps, applicationSidebarDispatch);
var applicationCustomFieldsTabProps = createStructuredSelector({
  applicationId: applicationIdSelector,
  studentId: applicationStudentIdSelector,
  email_suffix: applicationOldStudentIdSelector
});
export var applicationCustomFieldsEnhancer = connect(applicationCustomFieldsTabProps, null);

// -- DUPLICATED FROM ab-common -- //

// -------------------------------------------------------------
// Application Notes Actions
// -------------------------------------------------------------
var createNewNote = function createNewNote() {
  var privateNote = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(dispatch, getState) {
      var applicationId, key, loadingAction, setAdding, noteSelector, onProgress, jsonData, files, data, response, error;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            applicationId = applicationIdSelector(getState());
            key = privateNote ? 'private_note_attachments' : 'note_attachments';
            loadingAction = privateNote ? notesSetNewPrivateNoteLoadingAction : notesSetNewNoteLoadingAction;
            setAdding = privateNote ? notesSetAddingPrivateAction : notesSetAddingAction;
            noteSelector = privateNote ? newPrivateNoteSelector : newNoteSelector;
            dispatch(loadingAction({
              percentage: 0
            }));
            onProgress = function onProgress(info) {
              if (info.lengthComputable) {
                dispatch(loadingAction({
                  percentage: Math.trunc(info.loaded / info.total)
                }));
              }
            };
            jsonData = _.clone(noteSelector(getState()));
            jsonData.visibility = privateNote ? 'private' : 'public';
            jsonData.note_template_id = jsonData.template && jsonData.template.id;
            files = _.map(getObject(key), function (attachment) {
              return attachment.original;
            });
            delete jsonData.files;
            delete jsonData.dirty;
            delete jsonData.template;
            data = new FormData();
            Object.keys(jsonData).filter(function (k) {
              return !!jsonData[k];
            }).forEach(function (k) {
              data.append("note[".concat(k, "]"), jsonData[k]);
            });
            if (files && files.length > 0) {
              files.forEach(function (file) {
                data.append('note[attachments][]', file);
              });
            }
            response = null;
            error = null;
            _context9.prev = 19;
            _context9.next = 22;
            return createApplicationNoteRequest(applicationId, data, onProgress);
          case 22:
            response = _context9.sent;
            dispatch(setAdding(false, true));
            dispatch(notesInsertAction(response.data.note));
            dispatch(clearNewNoteAttachments(privateNote));
            storeObject(key, []);
            _context9.next = 35;
            break;
          case 29:
            _context9.prev = 29;
            _context9.t0 = _context9["catch"](19);
            console.error(_context9.t0);
            console.error(_context9.t0.response);
            error = _context9.t0;
            showErrors(_context9.t0);
          case 35:
            dispatch(loadingAction(null));
            if (!error) {
              _context9.next = 38;
              break;
            }
            throw error;
          case 38:
            return _context9.abrupt("return", response);
          case 39:
          case "end":
            return _context9.stop();
        }
      }, _callee9, null, [[19, 29]]);
    }));
    return function (_x17, _x18) {
      return _ref9.apply(this, arguments);
    };
  }();
};
var deleteNote = function deleteNote(noteId) {
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(dispatch, getState) {
      var applicationId, response;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            applicationId = applicationIdSelector(getState());
            _context10.prev = 1;
            _context10.next = 4;
            return deleteApplicationNoteRequest(applicationId, noteId);
          case 4:
            response = _context10.sent;
            dispatch(notesDeleteAction(noteId));
            raiseSuccessMessage('Successfully deleted note');
            return _context10.abrupt("return", response);
          case 10:
            _context10.prev = 10;
            _context10.t0 = _context10["catch"](1);
            showErrors(_context10.t0);
          case 13:
            return _context10.abrupt("return", undefined);
          case 14:
          case "end":
            return _context10.stop();
        }
      }, _callee10, null, [[1, 10]]);
    }));
    return function (_x19, _x20) {
      return _ref10.apply(this, arguments);
    };
  }();
};
var replyToNote = function replyToNote(note, privateNote) {
  return function (dispatch, getState) {
    var state = getState();
    var adding = privateNote ? addingPrivateNotes(state) : addingNotes(state);
    var permissions = permissionsSelector(state) || {};
    var name = note.author.first_name || note.author.last_name;
    var title = "Re: ".concat(note.title ? note.title : '').trim();
    var info = {
      title: title,
      body: "<p>Hi".concat(name ? " ".concat(name) : '', ",</p><p><br></p><p><br></p><p><br></p>").concat(adding ? '' : '<p><br></p>'),
      visibility: note.visibility,
      restricted: note.restricted,
      dirty: false
    };
    if (permissions.notes_initialize && note.visibility === 'private') {
      info.body = ' ';
    }
    dispatch(privateNote ? notesUpdateNewPrivateNoteAction(info) : notesUpdateNewNoteAction(info));
    dispatch(privateNote ? notesSetAddingPrivateAction(true, false, note.visibility) : notesSetAddingAction(true, false, note.visibility));
  };
};
var batchSendNote = function batchSendNote(note) {
  return (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function (dispatch, getState) {
      dispatch(multipleNotesSetNote(note));
      dispatch(multipleNotesShow());
    }
  );
};
var newNoteAttachment = function newNoteAttachment(file) {
  var privateNote = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch) {
    var key = privateNote ? 'private_note_attachments' : 'note_attachments';
    var plain = _.toPlainObject(file);
    var noteAttachments = getObject(key) || [];
    storeObject(key, [].concat(_toConsumableArray(noteAttachments), [{
      original: file,
      plain: plain
    }]));
    dispatch(privateNote ? notesAddFileNewPrivateNoteAction(plain) : notesAddFileNewNoteAction(plain));
  };
};
var removeNewNoteAttachment = function removeNewNoteAttachment(id) {
  var privateNote = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch) {
    var key = privateNote ? 'private_note_attachments' : 'note_attachments';
    var noteAttachments = getObject(key) || [];
    storeObject(key, _.filter(noteAttachments, function (note, index) {
      return index !== id;
    }));
    dispatch(privateNote ? notesRemoveFileNewPrivateNoteAction(id) : notesRemoveFileNewNoteAction(id));
  };
};
var clearNewNoteAttachments = function clearNewNoteAttachments() {
  var privateNote = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return function (dispatch) {
    var key = privateNote ? 'private_note_attachments' : 'note_attachments';
    storeObject(key, []);
    dispatch(privateNote ? notesClearFilesNewPrivateNoteAction() : notesClearFilesNewNoteAction());
  };
};

// used by the NewNote component
var newNoteProps = createStructuredSelector({
  note: newNoteSelector,
  userPermissions: permissionsSelector,
  agentId: applicationAgentId
});
var newNoteDispatch = function newNoteDispatch(dispatch) {
  return {
    onSave: function onSave() {
      return dispatch(createNewNote());
    },
    onCancel: function onCancel() {
      storeObject('note_attachments', []);
      return dispatch(notesSetAddingAction(false, true));
    },
    onChange: function onChange(info) {
      return dispatch(notesUpdateNewNoteAction(info));
    },
    addFile: function addFile(file) {
      return dispatch(newNoteAttachment(file));
    },
    removeFile: function removeFile(id) {
      return dispatch(removeNewNoteAttachment(id));
    },
    clearFiles: function clearFiles() {
      return dispatch(clearNewNoteAttachments());
    },
    onCreateFromTemplate: function onCreateFromTemplate(trackEvent) {
      return dispatch(createNoteFromTemplate(false, trackEvent));
    }
  };
};

// Used by Notes/NewNote
export var newNoteEnhancer = connect(newNoteProps, newNoteDispatch);
var newPrivateNoteProps = createStructuredSelector({
  note: newPrivateNoteSelector,
  userPermissions: permissionsSelector
});
var newPrivateNoteDispatch = function newPrivateNoteDispatch(dispatch) {
  return {
    onSave: function onSave() {
      return dispatch(createNewNote(true));
    },
    onCancel: function onCancel() {
      storeObject('private_note_attachments', []);
      return dispatch(notesSetAddingPrivateAction(false, true, 'private'));
    },
    onChange: function onChange(info) {
      return dispatch(notesUpdateNewPrivateNoteAction(info));
    },
    addFile: function addFile(file) {
      return dispatch(newNoteAttachment(file, true));
    },
    removeFile: function removeFile(id) {
      return dispatch(removeNewNoteAttachment(id, true));
    },
    clearFiles: function clearFiles() {
      return dispatch(clearNewNoteAttachments(true));
    },
    onCreateFromTemplate: function onCreateFromTemplate(trackEvent) {
      return dispatch(createNoteFromTemplate(true, trackEvent));
    }
  };
};

// Used by Notes/NewNote
export var newPrivateNoteEnhancer = connect(newPrivateNoteProps, newPrivateNoteDispatch);

// used by the Note component
var noteProps = createStructuredSelector({});
var noteDispatch = function noteDispatch(dispatch) {
  return {
    onDelete: function onDelete(noteId) {
      return dispatch(deleteNote(noteId));
    },
    onReply: function onReply(note) {
      return dispatch(replyToNote(note, note.visibility === 'private'));
    },
    onBatchSend: function onBatchSend(note) {
      return dispatch(batchSendNote(note));
    }
  };
};

// Used by Notes/Note
export var noteEnhancer = connect(noteProps, noteDispatch);

// used to determine if a newly created note is loading or not
var newNoteLoadingProps = createStructuredSelector({
  newNoteLoading: newNoteLoadingSelector
});

// Used by Notes/NewNote
export var newNoteLoadingEnhancer = connect(newNoteLoadingProps);
var newPrivateNoteLoadingProps = createStructuredSelector({
  newNoteLoading: newPrivateNoteLoadingSelector
});

// Used by Notes/NewNote
export var newPrivateNoteLoadingEnhancer = connect(newPrivateNoteLoadingProps);